<template>
  <div class="form" v-if="isPromptActiveLocal ? true : false">
    <p class="form_title">Connexion</p>
    <p class="form_subtitle">
      <span class="yello_word">Y’ello</span>, veuillez vous connecter
    </p>
    <div class="form_field">
      <vs-input @keypress.enter="loginOTD()"
        autocomplete="off"
        name="email"
        class="w-full"
        v-model="email"
        label="Username / Numéro de téléphone"
        :danger="!!formErrors.username"
        :danger-text="formErrors.username ? formErrors.username[0] : ''"
      />
      <vs-input @keypress.enter="loginOTD()"
        type="password"
        autocomplete="off"
        name="password"
        class="w-full mt-1"
        v-model="password"
        label="Mot de passe"
        :danger="!!formErrors.password"
        :danger-text="formErrors.password ? formErrors.password[0] : ''"
      />
    </div>

    <vs-button
      color="#ffcc00"
      class="action_button text-dark"
      @click="loginOTD()"
      >Se connecter</vs-button
    >
  </div>
</template>

<script>
export default {
  name: "LoginOtd",
  data: () => ({
    email: "",
    password: "",
    checkbox_remember_me: false,
    formErrors: {},
  }),
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    callBackLoginOTD: {
      type: Function,
    },
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        if (this.isPromptActive) {
          //   this.resetErrors();
          this.formErrors = {}
        }
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.email != "" && this.password != "";
    },
  },
  methods: {
    checkLogin() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });

        return false;
      }
      return true;
    },
    loginOTD() {
      if (!this.checkLogin()) return;

      // Loading
      this.$vs.loading();

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
        },
      };

      this.$store
        .dispatch("auth/loginJWT", payload)
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.user.firstly == 1) {
            this.$router.push({ path: "/passwordUpdate" });
            localStorage.removeItem("auth_step");
          } else {
            // this.$store.commit('UPDATE_USER_INFO', JSON.stringify(response.data.user), {root: true});
            // this.$router.push("/dashboard");
            location.reload(true);
            localStorage.setItem(
              "userInfo",
              JSON.stringify(response.data.user)
            );
            // location.reload(true);
            localStorage.removeItem("auth_step");
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status == 422) {
            this.formErrors = error.response.data.errors;
          } else {
            this.formErrors = {};
            this.$vs.notify({
              title: "Erreur",
              text: error.response.data.message
                ? error.response.data.message
                : "Veuillez contacter l'administrateur",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },
    registerUser() {
      if (!this.checkLogin()) return;
      this.$router.push("/pages/register").catch(() => {});
    },
  },
};
</script>

<style>
.form {
  margin-top: 6%;
}
</style>